import React, {} from 'react';
import {connect} from "react-redux";
import {setSQFTAr3dPopup} from "../../../../../actions/sqftMenuFunctions";
import SqftFeaturesPopup3dButtons from "../../../../popups/sqftFeaturesPopup/sqftFeaturesPopup3dButtons";
//import GLBLoader from "../../ar3d/GLBLoader";
import ARWorkspace from "../../ar3d/ar/ARWorkspace";

const ArContent = (props) => {
  const {setSQFTAr3dPopup} = props;

  // useEffect(()=> {
  //   if (isMobile && cabinetsGlb) {
  //     new GLBLoader(cabinetsGlb);
  //   }
  // }, [isMobile, cabinetsGlb])

  const closeButtonClick = () => {
    setSQFTAr3dPopup(({isOpened: false, contentType: null}));
  }

  return (
    <div className="message-window-base ar-popup">
      <div className="">
        <div className="">
          {/*Agumented Reality*/}
        </div>
        <button className="button--close"
                onClick={() => closeButtonClick()} >
        </button>
      </div>
      <div className="ar-popup__content">
        <ARWorkspace/>
      </div>
      <div className="ar-popup__footer">
        <div className={"ar-popup__buttons"}>
          <SqftFeaturesPopup3dButtons />
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  ar3dPopup: store.sqftMenuState.ar3dPopup,
  cabinetsGlb: store.sqftState.cabinetsGlb,
  apiErrorMessage: store.sqftState.apiErrorMessage,
  isMobile: store.serverState.isMobile,
  abortRequestController: store.sqftState.abortRequestController,
});

const mapDispatchToProps = {
  setSQFTAr3dPopup
};


export default connect(mapStateToProps, mapDispatchToProps)(ArContent);
